import { GetRelationshipConfigsPayload } from 'app/modules/relationships/types';
import { U21NetworkGraphElementKeysToUpdate } from 'app/shared/components/Graphs/U21NetworkGraph';
import {
  BASE_CYTOSCAPE_OPTIONS,
  BASE_EDGE_STYLES,
  BASE_LABEL_STYLES,
  BASE_NODE_STYLES,
  CONCENTRIC_LAYOUT_OPTIONS,
} from 'app/shared/components/Graphs/constants';
import { CreditCard, User } from 'app/shared/components/Graphs/svgs';
import { CytoscapeOptions } from 'cytoscape';
import type { U21Palette } from 'vendor/material-minimal/palette';

export const GET_ALL_RELATIONSHIP_CONFIGS_PAYLOAD: GetRelationshipConfigsPayload =
  {
    offset: 1,
    limit: 1000,
    search: '',
    filters: [],
  };

export const RELATIONSHIP_CONFIG_MULTISELECT_PROPS = {
  label: 'Filter by relationship',
  placeholder: 'Select relationships...',
};

export const RELATIONSHIP_LAYOUT_OPTIONS = {
  ...CONCENTRIC_LAYOUT_OPTIONS,
  avoidOverlap: true,
  nodeDimensionsIncludeLabels: true,
};

export const getRelationshipAnalysisCytoscapeOptions = (
  palette: U21Palette,
): CytoscapeOptions => ({
  ...BASE_CYTOSCAPE_OPTIONS,
  layout: RELATIONSHIP_LAYOUT_OPTIONS,
  userZoomingEnabled: false,
  style: [
    {
      selector: 'node',
      style: {
        ...BASE_NODE_STYLES,
        'background-color': (node) => {
          if (node.data('isBaseNode')) {
            return palette.error.main;
          }
          return node.data('nodeType') === 'entity'
            ? palette.primary.main
            : palette.info.main;
        },
        'border-color': (node) => {
          if (node.data('isBaseNode')) {
            return palette.error.light;
          }
          return node.data('nodeType') === 'entity'
            ? palette.primary.light
            : palette.info.light;
        },
        'background-image': (node) =>
          node.data('nodeType') === 'entity' ? User : CreditCard,
        content: (node) => node.data('label') ?? '',
      },
    },
    {
      selector: 'edge',
      style: {
        ...BASE_EDGE_STYLES,
        content: (edge) => edge.data('label') ?? '',
        'curve-style': 'bezier',
        'target-arrow-shape': 'triangle',
        'source-arrow-shape': (node) =>
          node.data('undirected') ? 'triangle' : 'none',
        'arrow-scale': 0.75,
      },
    },
    {
      selector: 'label',
      style: {
        ...BASE_LABEL_STYLES,
        'min-zoomed-font-size': 8,
        'text-max-width': '80px',
      },
    },
    {
      selector: 'edge[label]',
      style: {
        ...BASE_LABEL_STYLES,
        'text-background-color': palette.error.lighter,
      },
    },
  ],
});

export const RELATIONSHIP_ELEMENT_KEYS_TO_UPDATE: U21NetworkGraphElementKeysToUpdate =
  { nodes: ['degree'], edges: [] };
